<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button
        variant="ghost"
        size="sm"
        class="h-7 gap-1 text-xs"
      >
        <Cpu class="size-3" />
        {{ selectedLabel }}
        <ChevronDown class="size-3" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start">
      <DropdownMenuItem
        v-for="provider in providers"
        :key="provider.id"
        @click="aiStore.setProvider(provider.id)"
      >
        <span :class="provider.id === aiStore.selectedProvider && 'font-medium'">
          {{ provider.name }}
        </span>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'

import { ChevronDown, Cpu } from 'lucide-vue-next'

import { useAiProviders } from '@/api/v2/queries'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useAiStore } from '@/stores/ai'

const aiStore = useAiStore()
const { data: providersData } = useAiProviders()

const providers = computed(() => providersData.value?.providers ?? [])

const selectedLabel = computed(() => {
  const p = providers.value.find((p) => p.id === aiStore.selectedProvider)
  return p?.name ?? 'AI Provider'
})

watch(providers, (list) => {
  if (list.length > 0 && !aiStore.selectedProvider) {
    aiStore.setProvider(list[0].id)
  }
}, { immediate: true })
</script>
